import { LoadingArea } from '@consigli/facade';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureFlag, useFeatureFlag, useFeatureFlagsReady } from '@/feature-flags';

import { UserProfilePage } from './user-profile-page';
import { UserProfileRedesignPage } from './user-profile-redesign-page';

/**
 * Chooses between the current profile page and the redesign.
 *
 * Waits for `useFeatureFlagsReady` rather than reading the flag alone: an unread
 * flag resolves to `false`, so rendering immediately would paint the old page
 * and then swap it once the first fetch lands.
 *
 * Modelled on project-list-route.tsx, which gates the same flag the same way.
 */
export const UserProfileRoute: FC = () => {
  const { t } = useTranslation();
  const ready = useFeatureFlagsReady();
  const redesigned = useFeatureFlag(FeatureFlag.AppRedesign);

  if (!ready) {
    return (
      <div className="flex items-center justify-center">
        <LoadingArea className="mx-auto mt-[25vh]" title={t('project-list.loading-title')} />
      </div>
    );
  }

  return redesigned ? <UserProfileRedesignPage /> : <UserProfilePage />;
};
